import { useSettings, useStyles } from '@wix/tpa-settings/react';
import settingsParams, {
  uninitializedVisibilitySettingsTrueValue,
} from '../settingsParams';
import { VisibilityKey } from './types';
import { useVisibilityExperiment } from './useVisibilityExperiment';

export function useVisibilityCheck() {
  const settings = useSettings();
  const styles = useStyles();
  const { isVisibilityStyleParamsEnabled } = useVisibilityExperiment();
  return {
    shouldBeVisible(key: VisibilityKey) {
      const settingsValue = settings.get(settingsParams[key]);
      if (isVisibilityStyleParamsEnabled) {
        return typeof settingsValue === 'boolean'
          ? settingsValue
          : styles
              .getStylesForAllBreakpoints()
              .some(({ booleans }) => booleans[key]);
      } else {
        return typeof settingsValue === 'boolean'
          ? settingsValue
          : settingsValue === uninitializedVisibilitySettingsTrueValue;
      }
    },
  };
}
